/* eslint import/prefer-default-export: "off" */

export const TRANSITION_DELAYS = {
	xs: 250,
	sm: 500,
	md: 1000,
	lg: 1500,
};

export const VIDEO_LABELS = {
	PLAY: 'Play',
	PAUSE: 'Pause',
};
